module.exports = __webpack_public_path__ + "img/money-bag 1.346b6349.svg";